module.exports = __webpack_public_path__ + "static/img/e5efe9666ff50082597a115201668480.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer.png
// module id = or/K
// module chunks = 1